import { MIME_TYPE_VIDEO_MP4 } from '@vestico/utils';

import { CropHints } from '../annotations';
import { Pose } from './pose';

// export const ImageSizes = [180, 240, 480, 720, 960, 1200, 1920, 'original'] as const;
// export type ImageSize = (typeof ImageSizes)[number];

export enum ImageSize {
  xxSmall = 180,
  xSmall = 240,
  small = 480,
  medium = 720,
  large = 960,
  xLarge = 1200,
  xxLarge = 1920,
  original = Number.MAX_SAFE_INTEGER,
}

export enum VideoSize {
  x640 = 640,
  x960 = 960,
  x1280 = 1280,
  x1920 = 1920,
  original = Number.MAX_SAFE_INTEGER,
}

export const VideoVersions = ['preview', 'full'] as const;
export type VideoVersion = (typeof VideoVersions)[number];

export type MediaItem = {
  path: string;
  coverPath?: string;
  mimeType: string;
  cropHints?: CropHints;
};

export type MediaContainer = {
  pose: Pose;
  mediaItems: MediaItem[];
};

const parsePath = (fullPath: string) => {
  const pathComponents = fullPath.split('/');
  const fileName = pathComponents.pop() ?? fullPath;
  const extensionStartIndex = fileName.lastIndexOf('.');
  const extension = extensionStartIndex !== -1 ? fileName.substring(extensionStartIndex) : '';
  const name = extensionStartIndex !== -1 ? fileName.substring(0, extensionStartIndex) : fileName;
  const directory = pathComponents.join('/');
  return { directory, name, extension };
};

const THUMBS_DIR = 'thumbs';

export const getImagePath = (fullResolutionImagePath: string, size: ImageSize, extension?: string): string => {
  if (size === ImageSize.original) {
    return fullResolutionImagePath;
  }
  const { directory, name, extension: pathExtension } = parsePath(fullResolutionImagePath);
  const finalExtension = extension ?? pathExtension;
  const imagePath = `${directory}/${THUMBS_DIR}/${name}_${size.valueOf()}x${size.valueOf()}${finalExtension}`;

  if (!imagePath) {
    throw new Error(`path must be initialized`);
  }

  return imagePath;
};

export const getVideoPath = (fullResolutionImagePath: string, version: VideoVersion, size: VideoSize, mimeType: string): string => {
  if (version === 'full' && mimeType === MIME_TYPE_VIDEO_MP4 && size === VideoSize.original) {
    return fullResolutionImagePath;
  }

  const { directory, name } = parsePath(fullResolutionImagePath);

  const tumbsSuffix = !directory.endsWith('thumbs') ? `/${THUMBS_DIR}` : '';
  const versionSuffix = version.valueOf();
  const sizeSuffix = size === VideoSize.original ? '' : `_${size.valueOf()}`;
  const videoPath = `${directory}${tumbsSuffix}/${name}_${versionSuffix}${sizeSuffix}.mp4`;

  return videoPath;
};

export const POST_MEDIA_STORAGE_METADATA_HEADERS = { cacheControl: 'public, max-age=2592000', 'Cache-Control': 'public, max-age=2592000' };
